import Vue from "vue";
import { CoolSelectPlugin } from 'vue-cool-select'
 
// paste the line below only if you need "bootstrap" theme
import 'vue-cool-select/dist/themes/bootstrap.css'
// paste the line below only if you need "material-design" theme
// import 'vue-cool-select/dist/themes/material-design.css'
// you can also import your theme
 
Vue.use(CoolSelectPlugin)